import gql from 'graphql-tag';

export default gql`
  mutation CreateProperty(
    $address: String!
    $size: Float!
    $code: String!
    $suburb: String
    $valuation: Float
    $rooms: Float!
    $erfNumber: String
    $salesAgent: String!
    $status: PropertyStatus
    $imageId: String
    $image: FileCreateInput
    $documents: DocumentCreateInput
    $stakeholders: StakeholderCreateInput
    $applications: ApplicationCreateInput
    $memberships: MembershipCreateInput
    $type: PropertyType
  ) {
    createProperty(
      data: {
        address: $address
        size: $size
        code: $code
        suburb: $suburb
        valuation: $valuation
        rooms: $rooms
        erfNumber: $erfNumber
        salesAgent: $salesAgent
        status: $status
        imageId: $imageId
        image: $image
        documents: $documents
        stakeholders: $stakeholders
        applications: $applications
        memberships: $memberships
        type: $type
      }
    ) {
      createdAt
      id
      updatedAt
      address
      size
      code
      suburb
      valuation
      rooms
      erfNumber
      salesAgent
      status
      type
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/mutations/CreateProperty.ts